export enum Status {
  Success = 'Success',
  Pending = 'Pending',
  Draft = 'Draft',
  Error = 'Error',
  InProgress = 'In progress',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
}
